import React from "react";
import ReactDom from "react-dom";

export default class CompareItem extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        const { type, order, imageUrl, title, onRemoveItem } = this.props;
        const isPlaceholder = type === "placeholder";

        const styles = {
            backgroundImage: imageUrl ? `url(${imageUrl})` : null
        };
        
        return (
            <li key={order} className="carousel-seat">
                <div className={"item row no-gutters " + (isPlaceholder ? "placeholder" : "")}>
                    <div className="col-3 d-flex justify-content-center">
                        <div className="item-image" style={styles}></div>
                    </div>
                    <div className="col">
                        <div className="item-title">{title}</div>
                        {isPlaceholder && <div className="item-subtitle">{this.props.translations != undefined ? this.props.translations.boxListingText : 'Remove'}</div>}
                        {!isPlaceholder && <a className="btn btn-link" onClick={() => onRemoveItem(this.props)} data-webm-clickvalue="remove-one" >{this.props.translations != undefined ? this.props.translations.removeText:'Remove'}</a>}
                    </div>
                </div>
            </li>
        );
    }
}